import styles from "./Tooltip.module.css";
import Union from '../../assets/Union.svg'

interface TooltipProps {
    text?: string;
    showCloseButton?: boolean;
    onClick?: () => void;
    onClose?: () => void;
    isTop?: boolean;
    right?: number;
    bottom?: number;
    width?: number;
    padding?: string
    margin?: string
}

export const Tooltip = ({text, showCloseButton, onClick, onClose, isTop, right = 0, bottom = 0, width = 240, padding='16px 12px', margin = '0px'}: TooltipProps) => {
    
    const handleCloseClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (onClose) onClose();
    };
    
    return (
    <div role="button" className={styles.widgetTooltip} onClick={onClick} style={{bottom: `${bottom}px`, right:`${right}px`, width: `${width}px` }}>
        <div style={{position: 'relative'}}>
            <img 
                src={Union}
                alt="Assistent avatar" 
                style={{transform: isTop ? 'scale(1, 1)' :'scale(1, -1)' }}
            />
            <p style={{padding: `${padding}`, margin: `${margin}`}}>{text}</p>
            {showCloseButton && <button onClick={handleCloseClick} className={styles.closeButtonSmall}>x</button>}
        </div>
    </div>
  )
}